export default {
  'common': {
    required: value => ( (value === 0 || value) && value.toString().length > 0) || '필수 입력 항목입니다..',
    length11: value => value && value.length < 12 || '11자리 이하 숫자로만 입력 가능합니다..',
    digit: value => /^\d+$/.test(value) || '숫자만 입력가능합니다.',
    mobile: value => /^0\d{1,2}-\d{3,4}-\d{4}$/.test(value) || '연락처 형식이 아닙니다. ex) 010-1234-5678 041-134-5678',
    email: value => /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/.test(value) || '이메일 형식이 아닙니다.',
    birth: value => /^(19|20)\d{2}-\d{2}-\d{2}$/.test(value) || '생년월일 형식이 아닙니다. ex) 1998-07-20',
    password: value => /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-8]).{8,200}$/.test(value) || '비밀번호 형식이 아닙니다.',
    alphanumeric: (value, msg) => /^\w+$/.test(value) || msg,
    // userId: value => /^\w+$/.test(value) || /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/.test(value) || '아이디 형식이 아닙니다. 아이디는 영문,숫자 또는 이메일 형식만 입력바랍니다.'
    loginId: value => /^\w+$/.test(value) || '아이디 형식이 아닙니다. 아이디는 영문,숫자 형식만 입력바랍니다.',
    zipcode: value => !!value && /^\d{5,6}$/.test(value) || '우편번호 형식이 아닙니다.\n\r5~6자리 숫자로 입력해주세요.'
  }
}
